import { LString, t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { getLocalizedList, getLocalizedText } from 'core/utils/localized';
import { ReactComponent as CheckIcon } from '../../../personal-plan-metabolism/styles/checkGrayIcon.svg';
import { ReactComponent as GiftIcon } from '../../../personal-plan-metabolism/styles/giftIcon.svg';
import { renderHighlightedTitle } from 'src/onboarding/helpers/renderHighlightedTitle';
import { forwardRef, Ref } from 'react';
import getLocale from 'src/localization/get-locale';

interface Product {
  name: LString;
  plan_end_days: string;
  subTitle: any;
  title: any;
  price: any;
}

interface TryFoodzeeComponentProps {
  product: Product;
}

export const TryFoodzeeComponent = forwardRef(
  (props: TryFoodzeeComponentProps, ref: Ref<HTMLDivElement>) => {
    const { product } = props;
    const { name, plan_end_days, subTitle, title, price } = product;

    const { products, showPlanDescription, tryFoodzee } = useRemoteConfig();

    const getOptions = () => {
      const locale = getLocale();
      const baseOptions = getLocalizedList(tryFoodzee.options, locale);

      if (showPlanDescription) {
        const trialText = t('onboarding.personalPlanMetabolism.tryFoodzee.trial')
          .replace('$4.99', `$${subTitle}`)
          .replace('$39.99', `$${price}`);

        return [...baseOptions, trialText];
      }

      return baseOptions;
    };

    const options = getOptions();
    const locale = getLocale();

    return (
      <div className={styles.tryFoodzeeContainer}>
        <Title tag='h4'>
          {renderHighlightedTitle(getLocalizedText(tryFoodzee.tryFoodzeeTitle, locale))}
        </Title>
        <div className={styles.featuresList}>
          {options.map((feature, index) => (
            <div key={index} className={styles.featureItem}>
              <CheckIcon />
              <Text size='m' medium className={styles.featureText}>
                {feature}
              </Text>
            </div>
          ))}
        </div>

        <div ref={ref}>
          <div className={styles.promoSection}>
            <div className={styles.discountInfo}>
              <GiftIcon />
              <div>
                <Text size='m' bold>
                  {getLocalizedText(tryFoodzee.discount.title, locale)}
                </Text>
                <Text size='m' regular>
                  {getLocalizedText(tryFoodzee.discount.subTitle, locale)}
                </Text>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.pricingInfo}>
          <Text size='l' semibold>
            {t('onboarding.personalPlanMetabolism.tryFoodzee.total')}
          </Text>
          <div className={styles.prices}>
            <div className={styles.pricesNew}>
              <Text size='m' medium className={styles.originalPrice}>
                {typeof products[0]?.textLineThrough === 'string' && products[0].textLineThrough}
              </Text>
              <Text size='l' semibold className={styles.discountedPrice}>
                {subTitle}
              </Text>
            </div>
            <Caption size='l' className={styles.savingsText}>
              {getLocalizedText(tryFoodzee.discount.subTitle, locale)}
            </Caption>
          </div>
        </div>
      </div>
    );
  }
);
